import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/internal/Subscription';
import { AuthService } from 'src/app/core/services/auth.service';
import { EditMyProfileComponent } from '../../../private/edit-my-profile/edit-my-profile.component';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'th-out-of-office-banner',
  templateUrl: './out-of-office-banner.component.html',
  styleUrls: ['./out-of-office-banner.component.scss'],
  imports: [NgClass, EditMyProfileComponent]
})
export class OutOfOfficeBannerComponent implements OnInit, OnDestroy {
  isOutOfOffice: boolean = false;
  loggedOutSubscription: Subscription;
  userUpdatedSubscription: Subscription;
  isLoggedIn = false;

  constructor(
    private authService: AuthService,
    private modalService: NgbModal,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.isLoggedIn = this.authService.isAuthenticated();

    if (this.isLoggedIn) {
      this.updateOutOfOfficeStatus(this.authService.user);
    }

    this.userUpdatedSubscription = this.userService.authenticatedUserUpdate.subscribe((user) => {
      if (this.authService.isAuthenticated() && user) {
        this.isLoggedIn = true;
        this.updateOutOfOfficeStatus(user);
      }
    });

    this.loggedOutSubscription = this.authService.loggedOut.subscribe(() => {
      this.isLoggedIn = false;
      this.isOutOfOffice = false;
    });
  }

  ngOnDestroy() {
    this.loggedOutSubscription?.unsubscribe();
    this.userUpdatedSubscription?.unsubscribe();
  }

  private updateOutOfOfficeStatus(user: User) {
    if (this.authService.isAuthenticated() && user) {
      this.isOutOfOffice = user.isOutOfOffice || false;
    } else {
      this.isOutOfOffice = false;
    }
  }

  openOutOfOfficeModal(templateRef: TemplateRef<unknown>) {
    if (this.authService.isEntitled('/users/updateMyUserProfile.html') && templateRef) {
      this.modalService.open(templateRef, { size: 'lg' });
    }
  }
}
